module.exports = {
	letbanehome: '/',
	paymentcomplete: '/paymentcomplete/',
	paymentstatus: '/paymentstatus/',
	paymentreceipt: '/receipt/',
	letbaneerror: '/error/',
	nembillet: '/nembillet/',
	terms: '/terms/'
}
